import { Directive, Input, OnInit, ElementRef, SimpleChanges, OnChanges } from '@angular/core';

import tippy, { Placement, Instance, Props } from 'tippy.js';

import { TIPPY_ROUND_ARROW_SVG } from '@/utils/tippy-arrow';

@Directive({
  standalone: true,
  selector: '[tippy]'
})

export class TippyDirective implements OnInit, OnChanges {

  @Input('options') public options!: Partial<Props> | undefined;

  private instance!: Instance<Props>;

  constructor(
    private el: ElementRef
  ) {}

  public ngOnInit() {}

  public ngOnDestroy() {
    this.instance?.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    const el = this.el.nativeElement as HTMLElement;

    if (this.el.nativeElement._tippy) {
      const tippy = this.el.nativeElement._tippy as Instance;
      tippy.destroy();
    }

    if (!this.options?.content) return;

    el.style.cursor = 'default';
    const position = el.dataset.tippyPosition as Placement;
    const appendTo = el.dataset.appendTo as Element | "parent" | ((ref: Element) => Element);

    this.instance = tippy(el, {
      ...this.options,
      // content: el.dataset.tippyContent,
      zIndex: 21474841,
      theme: this.options?.theme ?? 'punks',
      // hideOnClick: false,
      arrow: this.options?.arrow ?? TIPPY_ROUND_ARROW_SVG,
      allowHTML: true,
      delay: this.options?.delay ?? [400, 500], // [show ms, hide ms]; default show delay avoids tooltips flashing on quick hover
      interactive: true // Permet de garder la tooltip ouverte quand la souris est dessus
    });

    if (position) this.instance.props.placement = position;
    if (appendTo) this.instance.props.appendTo = appendTo;
  }

}
